import { Injectable } from '@angular/core';
import { Place } from '@aws-sdk/client-location';
import { IAwsPlace } from '../interfaces/IAwsPlace';


const AWS_LOCATION_REGION = 'us-east-1';
const AWS_LOCATION_PLACE_INDEX_NAME = 'v1.public.eyJqdGkiOiJhYjIyMTAyYS05NmY5LTQ2ZTMtYjM2MS1kNzRkZjBmZmEzOGQifYnGkaXd5LxVMhFCaojhL7OeWompSA7thLUNQlavO3qbNguK0lokBuf7FKA_KuYvLaN1GZVnmoSzV3Mm4P_jzESLCQPDQz60cAxybVqnE5s4_4kQhN91DvU_xHnVpeWGkQdWksWo3C03blfaJIqUlcZM2sxYCvkRuRSD8l1tImm-Tgw7tOTLVid2QCWlHpvIMdcufyAchlUvH8fJDBTLkovXYJMQVwn0Jy6RF_tJYSWK3hj_718-gC8RB-pl1Xd4b_a5ZVIzW08kdLc1nZ1uVQVV1wgbffGRvPmfxH0po3icUUSLt6ye206MN86J1UTaZHzup01qbpxRKqUXoifLLUk.ZWU0ZWIzMTktMWRhNi00Mzg0LTllMzYtNzlmMDU3MjRmYTkx';
const AWS_LOCATION_API_KEY = 'v1.public.eyJqdGkiOiJhYjIyMTAyYS05NmY5LTQ2ZTMtYjM2MS1kNzRkZjBmZmEzOGQifYnGkaXd5LxVMhFCaojhL7OeWompSA7thLUNQlavO3qbNguK0lokBuf7FKA_KuYvLaN1GZVnmoSzV3Mm4P_jzESLCQPDQz60cAxybVqnE5s4_4kQhN91DvU_xHnVpeWGkQdWksWo3C03blfaJIqUlcZM2sxYCvkRuRSD8l1tImm-Tgw7tOTLVid2QCWlHpvIMdcufyAchlUvH8fJDBTLkovXYJMQVwn0Jy6RF_tJYSWK3hj_718-gC8RB-pl1Xd4b_a5ZVIzW08kdLc1nZ1uVQVV1wgbffGRvPmfxH0po3icUUSLt6ye206MN86J1UTaZHzup01qbpxRKqUXoifLLUk.ZWU0ZWIzMTktMWRhNi00Mzg0LTllMzYtNzlmMDU3MjRmYTkx';

export interface AwsPlace {
  Label?: string;
  Street?: string;
  Municipality?: string;
  Region?: string;
  PostalCode?: string;
  Country?: string;
}


@Injectable({
  providedIn: 'root'
})
export class AwsLocationService {
  async searchPlaceIndexForText(query: string): Promise<IAwsPlace[]> {
    const trimmedQuery = query?.trim();
    if (!trimmedQuery) {
      return [];
    }
   

    const endpoint = new URL(
      `https://places.geo.${AWS_LOCATION_REGION}.amazonaws.com/v2/autocomplete?key=${AWS_LOCATION_API_KEY}`
    );
    endpoint.searchParams.set('Text', trimmedQuery);
    endpoint.searchParams.set('MaxResults', '10');
    endpoint.searchParams.set('key', AWS_LOCATION_API_KEY);

    const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          QueryText: query,
          MaxResults: 8
        })
      });

    if (!response.ok) {
      console.warn(`AwsLocationService search failed with status ${response.status}.`);
      return [];
    }

    const result = (await response.json()) ;

    return result.ResultItems as IAwsPlace[];
  }
}
